export default {
  common: {
    nav: {
      home: "Startseite",
      find_offer_help: "Hilfe finden / anbieten",
      celebrate: "Ein Leben feiern",
      family_tree: "Stammbaum",
      events: "Veranstaltungen",
      civic_reports: "Bürgerberichte",
      neighborhood_pulse: "Nachbarschaftspuls",
      weather: "Wetter",
      nature: "Natur",
      marketplace: "Marktplatz",
      news: "Nachrichten",
      causes: "Anliegen",
      more: "Mehr",
    },
    header: { sign_in: "Anmelden", join: "Social Pulse beitreten", language: "Sprache", search: "Suchen" },
    tagline: "Gemeinschaften verbinden · Leben stärken · Sozialkapital aufbauen",
    locality: {
      viewing_from: "Sie sehen von",
      help_improve: "Helfen Sie uns, Ihren Standort zu verbessern",
      filter_by_country: "Nach Land filtern",
      change: "Ändern",
      set_your_location: "Standort festlegen",
      set_your_location_hint: "— tippen zum Anpassen",
    },
    actions: {
      submit_cause: "Anliegen einreichen",
      make_donation: "Unterstützen Sie Social Pulse — Jetzt spenden",
      browse_all: "Alle Bereiche durchsuchen",
    },
    news: {
      title: "Ihr tägliches Briefing.",
      submit_news: "Nachricht einreichen",
      archive: "Archiv",
      weather_nature: "Wetter & Natur",
      play_briefing: "Tägliches Briefing abspielen",
      play_briefing_hint: "Hören Sie die Top-{{count}}-Nachrichten · ~{{minutes}} Min. · in Ihrer Sprache",
      read_original: "Original lesen",
      view_brief: "Kurzfassung",
      also_reported_by: "Auch berichtet von:",
      translate: "Übersetzen",
      listen: "Anhören",
      stop: "Stopp",
    },
  },
};
